// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { priceStyles } from "@sc/Overrides/Widgets/ProductDetails/ProductDetailsPrice";
import { css } from "styled-components";

priceStyles.productPrice = {
    wrapper: {
        css: css`
            width: auto;
            margin-bottom: 8px;
        `,
    },
    price: {
        priceText: {
            css: css`
                margin-bottom: 0;
                font-size: 20px;
                line-height: 28px;
                font-weight: bold;
            `,
        },
        unitOfMeasure: {
            unitOfMeasureText: {
                css: css`
                    white-space: nowrap;
                    font-size: 14px;
                    line-height: 22px;
                `,
            },
        },
    },
    failedToLoadPricingWrapper: {
        css: css`
            display: flex;
            align-items: center;
            margin-bottom: 8px;
        `,
    },
};
